module.exports = __webpack_public_path__ + "img/scene3.8c85d1c3.webp";